import { OverlayProvider } from '@react-aria/overlays';
import { fn } from '@storybook/test';
import { useState } from 'react';

import type { Meta, StoryFn } from '@storybook/react';
import type { DrawerProps } from './Drawer';

import { Drawer } from './Drawer';

import { Button } from 'components/Buttons';
import { ButtonGroup } from 'components/ButtonGroup';

const codeString = `
  <Drawer isOpen={isOpen} onClose={onCloseFunction} title={title} buttons={buttons}> {children} </Drawer>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/Drawer',
  component: Drawer,
  argTypes: {
    isOpen: {
      table: {
        disable: true,
      },
    },
    buttons: {
      table: {
        disable: true,
      },
    },
    closeButtonAriaValueText: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Drawer,
    codeString: codeString,
  },
} as Meta<DrawerProps>;

const Template: StoryFn<DrawerProps> = (args) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <OverlayProvider>
      <Button onClick={() => setIsOpen(!isOpen)} variant="primary">
        Open drawer
      </Button>
      {isOpen && (
        <Drawer
          {...args}
          isOpen={isOpen}
          onClose={() => {
            fn()();
            return setIsOpen(!isOpen);
          }}
        >
          Example Drawer Content
        </Drawer>
      )}
    </OverlayProvider>
  );
};

const defaultArgs: Partial<DrawerProps> = {
  title: 'Example Title',
  closeButtonAriaValueText: 'Close',
};

export const DrawerExample = Template.bind({});
DrawerExample.args = {
  ...defaultArgs,
};

export const WithButtons = Template.bind({});
WithButtons.args = {
  ...defaultArgs,
  buttons: (
    <ButtonGroup>
      <Button variant="primary">Primary Example Button</Button>
      <Button variant="secondary">Secondary Example Button</Button>
    </ButtonGroup>
  ),
};
